/**
 * Playfield geometry helpers — rounded-rect hit tests in world space.
 */

import { BEDROOM_DEFAULT } from './bedroom.js';

/** True when (x, y) lies inside the playable rounded rectangle. */
export function isPointInPlayfield(x: number, y: number): boolean {
  const w = BEDROOM_DEFAULT.bedWidth;
  const h = BEDROOM_DEFAULT.playfieldHeight;
  const r = BEDROOM_DEFAULT.cornerRadius;
  if (x < 0 || y < 0 || x > w || y > h) return false;

  const cr = Math.max(0, Math.min(r, w / 2, h / 2));
  if (cr === 0) return true;

  if (x < cr && y < cr) {
    const dx = cr - x;
    const dy = cr - y;
    return dx * dx + dy * dy <= cr * cr;
  }
  if (x > w - cr && y < cr) {
    const dx = x - (w - cr);
    const dy = cr - y;
    return dx * dx + dy * dy <= cr * cr;
  }
  if (x < cr && y > h - cr) {
    const dx = cr - x;
    const dy = y - (h - cr);
    return dx * dx + dy * dy <= cr * cr;
  }
  if (x > w - cr && y > h - cr) {
    const dx = x - (w - cr);
    const dy = y - (h - cr);
    return dx * dx + dy * dy <= cr * cr;
  }
  return true;
}
